
import React, { useState, useRef, useEffect } from 'react';
import './style.scss'
import PropTypes from 'prop-types';
import {
   MediaChip,
   MediaInfoChip,
   MediaButton,
   MediaLableItem,
   MediaMemberBottonOptions,
   MediaAgeVerificationFrame as AgeVerificationFrame,
} from 'common/components/modules/media';
import Icon from 'common/components/elements/icons';
import TruncateText from 'common/components/elements/truncate-text';
import { filterBadWords } from 'common/utils/filter-bad-words';
import DateFormatter from 'common/utils/DateFormatter';
import cx from 'classnames';
import ConfirmModal from 'common/components/modules/modal-wrapper';
import CircleLoader from 'common/components/elements/loader/circle';
import PreviewVideo from 'common/components/modules/preview-video';
import { PreviewVideoFullScreen } from 'common/components/modules/preview-video/modules';
import { BlurhashCanvas } from 'react-blurhash';
import storeHelper from 'common/utils/store-helper';

const MediaCardTitle = ({
   media,
   isAgeVerificationRequired,
   isLoading,
   type,
   contentCardSettings,
}) => {
   const isShowTimestamp = () => {
      return  contentCardSettings?.timestamp && ['video', 'photoset'].includes(type);
   }

   const getDescriptionText = () => {
      let text = `${ DateFormatter.getDate(media.publish_date) }`;
      if(!!media.is_future_publish_enabled){
         text = 'Coming soon';
      }
      return text;
   }
   const title = media?.title || media?.name
   return (
      <div className='flex flex-col'>
         {
            !isLoading && (
               <div className='flex gap-1.5'>
                  {
                     Boolean(media?.is_pinned)  &&
                     <Icon
                        name='pin'
                        color='warning'
                        darkColor='warning-dark'
                        className='h-5 w-5 min-h-[20px] min-w-[16px] rotate-[35deg]'
                        size='xl'
                        data-tooltip-content='Pinned'
                        data-tooltip-id='ams-top-tooltip'
                     />
                  }
                  <TruncateText
                     text={ isAgeVerificationRequired ? filterBadWords(title) : title }
                     textClass='text-xl font-bold text-major leading-6 dark:text-major-dark title dark:shadow-none'
                     textSize='20px'
                     fontWeight='700'
                  />

               </div>
            )
         }
         {
            isLoading && (<div className='loading-card h-6 w-full' />)
         }

         {
            isShowTimestamp() && (
               <>
                  {
                     isLoading && (
                        <div className='loading-card h-4 w-full' />
                     )
                  }
                  {
                     !isLoading && (
                        <span className=' text-placeholder dark:text-placeholder-dark panel-description'>
                           {type === 'video' ? 'Video •' : 'Photoset •'} {getDescriptionText()}
                        </span>
                     )
                  }
               </>
            )
         }

      </div>
   )
}
const MediaTopLables = ({
   media,
   contentCardSettings,
   type,
   isMediaContent,
   isProduct,
   toggleWatchStatus,
}) => {
   const showComingSoon = !!media.is_future_publish_enabled;
   const isPreRelease = 'pre_release' === media.stream_status && 'need_to_soon' !== media.stream_state && showComingSoon;
   const [markUnwatchedDisabled, setMarkUnwatchedDisabled] = useState(false)
   return (
      <>
         {/* Labels positioned at the top right corner of the card  */}
         {
            isMediaContent && media.watched && 'free' === media.stream_state && Boolean(toggleWatchStatus) && (
               <MeidaLableWrapper
                  position='top-left'
               >
                  <MediaButton
                     iconName='views'
                     dataToolTipContent='Mark as unwatched'
                     onClick={ (e) => {
                        e.preventDefault()
                        setMarkUnwatchedDisabled(true)
                        toggleWatchStatus(() => setMarkUnwatchedDisabled(false))
                     } }
                     disabled={ markUnwatchedDisabled }
                  />
               </MeidaLableWrapper>

            )
         }
         {/* Labels positioned at the top right corner of the card  */}
         <MeidaLableWrapper>
            {
               isMediaContent && (media.duration || media.photos_count) && (
                  <div
                     id={ `${ type }_media_chip_${ media.id }` }
                     className='flex gap-2 flex-row-reverse ml-auto'
                  >
                     <MediaChip
                        countOrDuration={ type === 'photoset' ? media.photos_count : media.duration }
                        type={ type === 'photoset' ? 'photoset' : 'video' }
                        isBlurBackground={ false }
                     />
                  </div>
               )
            }
            {
               isProduct && storeHelper.getStorePrice(media) && (
                  <MediaLableItem
                     text={ storeHelper.getStorePrice(media) }
                  />
               )
            }
         </MeidaLableWrapper>


         {/* Labels positioned at the top left corner of the card */}
         <MeidaLableWrapper
            position='top-left'
         >
            {
               isProduct && media.product_type === 'attachment_item' && (
                  <MediaLableItem
                     iconName={ media?.attachment_type === 'rar' ? 'zip' : media?.attachment_type }
                     tooltipContent={ `Downloadable ${ media?.attachment_type !== 'audio' ? media?.attachment_type === 'image' ? 'Image' : `${ media?.attachment_type?.toUpperCase() } file` : 'Audio file' }` }
                  />
               )
            }
            {
               isProduct && media.product_type === 'content_bundle_item' && (
                  <>
                     {
                        media?.stream_status === 'available_member'  &&
                        <MediaLableItem
                           tooltipContent='Premium'
                           iconName='star'
                           iconColor='warning'
                           withoutBackground

                        />
                     }
                     <MediaLableItem
                        tooltipContent='Bundle'
                        iconName='bundle'
                     />
                  </>
               )
            }
            {
               isMediaContent &&  media.new && contentCardSettings?.new_label && (
                  <MediaInfoChip
                     text='NEW'
                  />
               )
            }
            {
               isMediaContent && media.is_updated && !media.watched &&  !!contentCardSettings.updated_label && (
                  <MediaInfoChip
                     text='Updated'
                  />
               )
            }
            {
               isMediaContent && isPreRelease && isMediaContent && (
                  <MediaLableItem
                     iconName='launch'
                     text='Prerelease'
                     withoutBackground
                  />
               )
            }
         </MeidaLableWrapper>


         {/* Labels positioned at the bottom left corner of the card */}
         <MeidaLableWrapper
            position='bottom-left'
         >
            {
               isProduct && !!media?.track_quantity && !showComingSoon && !!media?.show_availability && (
                  <MediaLableItem
                     iconName={ !!media?.number_in_stock_left ? 'store' : 'sold-out' }
                     text={ !!media?.number_in_stock_left ? `${ media?.number_in_stock_left } of ${ media?.number_in_stock } left` : media?.label }
                  />
               )
            }
         </MeidaLableWrapper>
         {/* -------------------------------------------------------------------------- */}
      </>
   )
}
const MediaContentButtonOptions = ({
   data,
   goToMediaDetails,
   isAuthUser,
   onClickTip,
   showShare = true,
   onShare,
   onClickLike,
   onClickLock,
   contentCardSettings,
   stream_state,
   onChangeFavoriteItem,
   collectionType,
   likeFetching,
   favoritFetching,
   type,
}) => {
   const showComment = !!data.comments_count && contentCardSettings?.total_comment_counts && !!data.can_read_comments;
   const showLock = Boolean(data.is_available_pricings && stream_state !== 'free');
   const canLike = Boolean(contentCardSettings?.like && isAuthUser && 'store' !== type)
   const canShare = Boolean(contentCardSettings?.share && !!showShare)
   const canSendTip = Boolean(contentCardSettings?.tip && isAuthUser && 'store' !== type)
   const canChangeFavorite = Boolean(isAuthUser && 'story' !== type)
   return (
      (!data.is_deleted  && (canLike || canShare || canSendTip || canChangeFavorite || showLock || showComment)) &&
         <div
            className='absolute left-0 bottom-0 flex gap-3 justify-between items-center z-40 w-full p-2 pt-3'
         >
            {
               (showLock || showComment) && (
                  <div
                     className='flex gap-3'
                  >
                     {

                        showLock && (
                           <MediaButton
                              iconName='lock'
                              onClick={ (e) => {
                                 e.preventDefault()
                                 e.stopPropagation()
                                 if(data?.is_available_pricings) {
                                    onClickLock()
                                 }
                              } }
                           />
                        )
                     }
                     {
                        showComment &&
                        <MediaButton
                           iconName='comment'
                           onClick={ (e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              goToMediaDetails()
                           } }
                           text={ data.comments_count }
                        />
                     }
                  </div>
               )
            }
            {
               (canLike || canShare || canSendTip || canChangeFavorite)  && (

                  <MediaMemberBottonOptions
                     onChangeFavoriteItem={ onChangeFavoriteItem }
                     isLiked={ data.is_liked }
                     id={ data.id }
                     isFavorite={ data.is_favorite }
                     onClickLike={ data.is_deleted ? null : () => onClickLike() }
                     canLike={ canLike }
                     canShare={ canShare }
                     canSendTip={ canSendTip }
                     canChangeFavorite={ canChangeFavorite }
                     onShare={ onShare }
                     onClickTip={ onClickTip }
                     collectionType={ collectionType }
                     likeFetching={ likeFetching }
                     favoritFetching={ favoritFetching }

                  />
               )
            }
         </div>
   )
}


const MediaTitile = ({
   title,
   isMobile,
   total,
   type,
   alignment,
   description,
   showContentCount,
}) => {
   return (
      <div
         className={ cx({
            'flex flex-col flex-1': true,
            'items-center': alignment === 'center',
         }) }
      >
         <div className='flex items-center gap-6'>
            {
               title && (
                  <h1
                     className={ cx({
                        'font-semibold text-major dark:text-major-dark': true,
                        'text-[24px] leading-[32px]': isMobile,
                        'text-[34px] leading-[40px]': !isMobile,
                     }) }
                  >
                     {title}
                  </h1>
               )
            }
            {
               showContentCount && (
                  <span className='text-sm text-secondary font-medium leading-[16px]'>
                     { `${ total || 0 } ${ type }s` }
                  </span>
               )
            }
         </div>
         {
            description && (
               <span
                  dangerouslySetInnerHTML={ {
                     __html: description,
                  } }
                  className='text-sm text-secondary font-medium leading-[16px] ql-editor' />
            )
         }
      </div>

   )
}


const MediaAgeVerificationFrame = ({
   onClickVerifyAgeButton = () => {},
   src,
}) => {
   return (
      <div
         style={ {
            backgroundColor: 'rgba(29, 41, 57, 0.3)',
         } }
         className='flex w-full h-full relative overflow-hidden mms-age-verivication'>
         <img
            src={ src }
            alt='poster'
            className='h-full object-center object-cover z-[1] pointer-events-none absolute inset-0 w-full'
            style={ {
               filter: 'blur(32px)',
            } }
         />
         <AgeVerificationFrame
            className='cover_image_wrapper_hover_element hidden z-10'
            onClickVerifyAgeButton={ onClickVerifyAgeButton }
         />
      </div>

   )
}

const MediaMembershipsForContentModal = ({
   // primaryColor,
   type,
   onCloseModal,
   isLoading,
   pricingsData,
   contentName,
   onSelectMembership,
   isAgeVerificationRequired,
}) => {
   const getIconName = () => {
      if(type === 'photoset'){
         return 'content'
      }
      if(type === 'video'){
         return 'videos'
      }
      return 'online-stream';
   }
   return (
      <ConfirmModal
         type='confirm'
         icon={ getIconName() }
         // iconColor='error'
         title={  isAgeVerificationRequired ? filterBadWords(contentName) : contentName }
         withoutConfirmButton
         withoutCancelButton
         withoutCloseButton={ false }
         onCloseModal={ onCloseModal }

      >
         {
            isLoading && (
               <div className='w-full flex items-center justify-center min-h-[100px]'>
                  <CircleLoader color='primary' />
               </div>

            )
         }
         {
            !isLoading && (
               <div className='w-full max-h-[487px] overflow-y-auto ams-custom-scrool text-start'>
                  <MediaListForPricing
                     pricing='unlocked'
                     data={ pricingsData.unlocked }
                     onSelectMembership={ onSelectMembership }
                     isAgeVerificationRequired={ isAgeVerificationRequired }
                  />
                  {
                     Object.keys(pricingsData.locked).map(key => (
                        <MediaListForPricing
                           key={ key }
                           pricing={ key }
                           data={ pricingsData.locked[key] }
                           onSelectMembership={ onSelectMembership }
                           isAgeVerificationRequired={ isAgeVerificationRequired }
                        />
                     ))
                  }
               </div>
            )
         }
      </ConfirmModal>
   )
}

const MediaListForPricing = ({
   pricing,
   data,
   onSelectMembership,
   isAgeVerificationRequired,
}) => {
   if(!Boolean(data.length)) {
      return null
   }
   return (
      <div
         className='border border-divider rounded-lg dark:border-divider-dark mt-4 overflow-hidden'
      >
         <div
            className={ cx({
               'w-full flex items-center gap-1 pl-3 pr-2.5 py-2.5': true,
               'bg-warning-12': pricing !== 'unlocked',
               'bg-success-12': pricing === 'unlocked',
            }) }
         >
            <Icon
               name={ pricing === 'unlocked' ? 'unlocked' : 'lock' }
               color={ pricing === 'unlocked' ? 'success' : 'warning' }
               size='xl'
               darkColor={ pricing === 'unlocked' ? 'success-dark' : 'warning-dark' }
            />
            <span className='text-sm leading-4 dark:text-major-dark'>
               {
                  pricing === 'unlocked' ? (
                     'Included with the following memberships'
                  ) : (
                     <>
                        Can be unlocked for &nbsp;
                        <span className='font-medium'>{ pricing } USD with the following membership</span>
                     </>


                  )
               }
            </span>
         </div>
         {
            data.map(item => (
               <div
                  key={ item.id }
                  className='w-full px-4 py-[7px] cursor-pointer hover:bg-hover dark:hover:bg-hover-dark'
                  role='presentation'
                  onClick={ () => onSelectMembership(item, item.is_update) }
               >
                  <div className='flex justify-between gap-2'>
                     <TruncateText
                        text={ isAgeVerificationRequired ? filterBadWords(item.name) : item.name }
                        textClass='leading-5 text-sm font-medium dark:text-major-dark group-hover:underline'
                        width='calc(100% - 30px)'
                        className='w-full group'
                     />
                     <span className='text-major dark:text-major-dark text-sm text-nowrap'>{item.is_update  ? 'Upgrade' : 'Select'}</span>
                  </div>
                  <span className='mt-1 text-xs text-secondary dark:text-secondary-dark '>{ item.usd_terms }</span>
               </div>
            ))
         }
      </div>
   )
}

const MediaLockedCard = ({
   blurhash,
   onClick,
}) => {
   return (
      <>
         <BlurhashCanvas
            hash={ blurhash  || 'LEHV6nWB2yk8pyo0adR*.7kCMdnj' }
            punch={ 1 }
            className='w-full h-full rounded-lg  absolute inset-0 z-[8]'
         />
         <div
            className='w-full h-full flex items-center justify-center z-[9] absolute cursor-pointer inset-0'
            style={ {
               backgroundColor: 'rgba(29, 41, 57, 0.3)',
               backdropFilter: 'blur(4px)',
            } }
            role='presentation'
            onClick={ (e) => {
               if(onClick){
                  onClick(e)
               }
            } }
         >
            <Icon
               size='[80px]'
               name='lock'
               className=' text-[80px] text-[#FFFFFF99] dark:text-[#FFFFFF99]'
               darkColor='#FFFFFF99'
               style={ {
                  opacity: '.9',
               } }
            />
         </div>

      </>
   )
}

const MediaPreviewVideo = ({
   poster,
   src, // Requaerd
   setLoaded,
   previewIsSFW,
   posterIsSfw,
   primaryColor,
   showPlayIcon = true,
   autoPlay,
   showVolumeButton,
   videoId,
   blurhash,
}) => {
   const screenWidth = 1026
   const [isAutoPlay, setIsAutoPlay] = useState(false);
   const [isVisible, setIsVisible] = useState(false);
   const [imgLoad, setImgLoad] = useState(true);
   const [openFullScreen, setOpenFullScreen] = useState(false);

   // const [videoLoaded, setVideoLoaded] = useState(false)
   const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
   }
   const callbackFunction = (entries) => {
      const [entry] = entries
      setIsVisible(entry.isIntersecting)
      if(screenWidth > 1024) {
         if(autoPlay){
            setIsAutoPlay(true);
         }
         return;
      }
      if(!videoRef.current) return
      if(isVisible) {
         setIsAutoPlay(true);
      }
   }

   const videoRef = useRef();
   useEffect(() => {
      if(!videoRef.current) return;
      const observer = new IntersectionObserver(callbackFunction, options)
      if(videoRef.current) {
         observer.observe(videoRef.current?.childNodes[0]);
      }

      return () => {
         if(!videoRef.current) return;
         // eslint-disable-next-line react-hooks/exhaustive-deps
         if(videoRef.current) observer.unobserve(videoRef.current?.childNodes[0])
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [videoRef, options])

   const getVoiceIconRightPosition = () => {
      let right = 16;
      // if(isShowBottomContent){
      const element = document.querySelector('#story-button-right-content')
      if(element && element.offsetWidth){
         right = element.offsetWidth + 8
      }
      // }
      return right
   }
   return (
      <>
         {
            openFullScreen && (
               <PreviewVideoFullScreen
                  openFullscreen={ true }
                  setOpenFullScreen={ (bool) => {
                     setOpenFullScreen(bool)
                     setIsAutoPlay(false)
                  } }
                  showVolumeButton={ showVolumeButton }
                  autoPlay={ true }
                  previewSrc={ src }
                  previewIsSFW={ previewIsSFW }
               />
            )
         }
         <div
            ref={ videoRef }
            onMouseEnter={ () => {
               if(!autoPlay && screenWidth > 1024) {
                  setIsAutoPlay(true)
               }
            } }
            onMouseLeave={ () => {
               if(!autoPlay && screenWidth > 1024) {
                  setIsAutoPlay(false)
               }
            } }
            role='presentation'
            className='focus-outline-card focus:outline-none h-full w-full'>
            <div
               className='w-full h-full bg-cover bg-center items-center justify-center flex relative bg-gray-200 dark:bg-gray-dark-200 z-[9]'
            >
               {
                  ((posterIsSfw && !isAutoPlay) ||  (previewIsSFW && isAutoPlay)) && (
                     <AgeVerificationFrame
                        className='cover_image_wrapper_hover_element hidden z-10'
                        onClickVerifyAgeButton={ _ => {} }
                     />
                  )
               }
               {
                  !poster && !isAutoPlay && (
                     <MediaLockedCard blurhash={ blurhash } />
                  )
               }

               {
                  poster && !isAutoPlay && (
                     <>
                        <MediaImageCard
                           setImgLoad={ () => setImgLoad(false) }
                           poster={ poster }
                           lockedForSFW={ posterIsSfw }
                        />
                        {
                           imgLoad && (
                              <div className='w-full h-full absolute inset-0 flex items-center justify-center'>
                                 <CircleLoader color='major-dark' />
                              </div>
                           )
                        }
                        {
                           !imgLoad && showPlayIcon && (
                              <Icon name='play-filled' style={ { fontSize: '54px' } } color='major-dark' className='z-10' />
                           )
                        }
                     </>
                  )
               }
               {
                  isAutoPlay && (
                     <PreviewVideo
                        previewSrc={ src }
                        showVolumeButton={ showVolumeButton }
                        poster={ poster }
                        voiceIconRightPosition={ getVoiceIconRightPosition() }
                        autoPlay={ isAutoPlay }
                        handelLoadedData={ () => {
                           if(setLoaded){
                              setLoaded(true)
                           }
                        } }
                        videoClassName='object-cover'
                        voiceButtonClassName='h-10 mb-2'
                        isLockedForSFW={ previewIsSFW }
                        primaryColor={ primaryColor }
                        videoId={ videoId }
                        setOpenFullScreen={ setOpenFullScreen }
                        openFullscreen={ openFullScreen }
                        showFullScreenButton={ !posterIsSfw }
                     >
                        {
                           !poster && (
                              <MediaLockedCard blurhash={ blurhash } />
                           )
                        }
                        {
                           poster && (
                              <MediaImageCard
                                 setImgLoad={ () => setImgLoad(false) }
                                 poster={ poster }
                                 lockedForSFW={ posterIsSfw }
                              />
                           )
                        }
                     </PreviewVideo>
                  )
               }
            </div>
         </div>
      </>
   );
}

const MediaImageCard = ({
   lockedForSFW,
   setImgLoad,
   poster,
}) => {
   return (
      <>
         <img
            onLoad={ () => {
               if(setImgLoad){
                  setImgLoad(false)
               }
            } }
            src={ poster }
            alt='thumbnail'
            className='w-full object-contain object-center h-full absolute inset-0 z-[9]'
            style={ {
               filter: lockedForSFW ? 'blur(32px)' : '',
            } }
         />
         <div
            className='absolute w-full h-full bg-no-repeat bg-cover inset-0 z-[8]'
            style={ {
               filter: `blur(8px)`,
               backgroundImage: `url(${ poster })`,
            } }
         />
      </>
   )
}

const MeidaLableWrapper = ({
   children,
   position = 'top-right',
   className,
}) => {
   if(!children) return null;

   return (
      <div
         className={ cx(
            {
               [`flex gap-2 z-20 absolute m-[10px] ${ className }`]: true,
               'top-0 right-0': position === 'top-right',
               'bottom-0 right-0': position === 'bottom-right',
               'top-0 left-0': position === 'top-left',
               'bottom-0 left-0': position === 'bottom-left',
            }
         ) }
      >
         {children  && children}
      </div>
   )
}

const MediaCardWrapper = ({
   media = {},
   type,
   isLoading,
   contentCardSettings,
   children,
   toggleWatchStatus,
}) => {
   const showComingSoon = !!media.is_future_publish_enabled;
   const endsIn = !!media?.show_public_countdown ? media?.ends_in : null
   let calculateTimeLeft = () => DateFormatter.calculateTimeLeft(endsIn)
   const [timeLeft, setTimeLeft] = useState(endsIn ? calculateTimeLeft() : null)
   // const [hideElement, setHideElement] = useState(false)

   useEffect(() => {
      let timer
      if(timeLeft !== null) {
         timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
         }, 1000);
      }

      return () => clearInterval(timer);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [timeLeft]);

   const isMediaContent = ['video', 'photoset', 'recorded_stream'].includes(type);
   const isProduct = 'store' === type;
   const isStory = 'story' === type;
   return (
      <div
         className={ cx(
            {
               'relative w-full overflow-hidden rounded-lg shadow-lg mms-age-verivication mms-card-wrapper group/mmsCard': true,
               'aspect-square': isStory,
               'aspect-video': !isStory,
            }
         ) }
      >
         {
            !isLoading && (
               <>
                  {
                     !isStory && !['vault_image', 'vault_video'].includes(type) && (
                        <MediaTopLables
                           media={ media }
                           contentCardSettings={ contentCardSettings }
                           type={ type }
                           isMediaContent={ isMediaContent }
                           isProduct={ isProduct }
                           toggleWatchStatus={ toggleWatchStatus }
                        />

                     )
                  }
                  {
                     showComingSoon && (isMediaContent || isProduct)  && (
                        <div
                           className='absolute group-hover/mmsCard:invisible h-full w-full mms-media-card-coming-soon-bg inset-0 z-10 text-major-dark flex flex-col items-center justify-center'
                        >
                           <div className='flex flex-col justify-between z-20'>
                              <span className='font-bold coming-soon-text text-center '>Coming soon</span>
                              <span className='leading-tight mt-2 text-center'>{DateFormatter.getDateLeft(media.publish_date, false, 'In a few minutes')}</span>
                           </div>
                        </div>
                     )
                  }
                  {
                     !!timeLeft && !showComingSoon &&
                     <div
                        className='absolute group-hover/mmsCard:invisible h-full w-full mms-media-card-coming-soon-bg inset-0 z-10 text-major-dark flex flex-col items-center justify-center'
                     >
                        <Icon
                           name='clock'
                           color='major-dark'
                           size='2xl'
                        />
                        <span className=' text-major-dark text-xl leading-4 font-medium select-none'>Ends in</span>
                        <span className=' text-major-dark block select-none'>{timeLeft}</span>
                     </div>
                  }

                  {children && children}
               </>
            )
         }
         {
            isLoading && (
               <div className='absolute inset-0 w-full h-full loading-card' />
            )
         }
      </div>
   );
}

const MediaPhotoCard = ({ photo, isAgeVerificationRequired }) => {
   return (
      <div>
         {
            photo.cf_thumb_path_photo && (
               <>
                  <MediaImageCard
                     poster={ photo.cf_thumb_path_photo }
                     lockedForSFW={ isAgeVerificationRequired && !photo.is_sfw }
                  />
                  {
                     isAgeVerificationRequired && !photo.is_sfw && (
                        <AgeVerificationFrame
                           className='cover_image_wrapper_hover_element hidden z-10'
                           onClickVerifyAgeButton={ _ => {} }
                        />
                     )
                  }
               </>
            )
         }
         {
            !photo.cf_thumb_path_photo && (
               <MediaLockedCard blurhash={ photo.blurhash } />
            )
         }
      </div>
   )
}

MediaPhotoCard.propTypes = {
   photo: PropTypes.object,
   isAgeVerificationRequired: PropTypes.bool,
};
MediaLockedCard.propTypes = {
   blurhash: PropTypes.string,
   onClick: PropTypes.func,
};
MediaPreviewVideo.propTypes = {
   previewIsSFW: PropTypes.bool,
   posterIsSfw: PropTypes.bool,
   showPlayIcon: PropTypes.bool,
   autoPlay: PropTypes.bool,
   showVolumeButton: PropTypes.bool,
   src: PropTypes.string,
   blurhash: PropTypes.string,
   poster: PropTypes.string,
   setLoaded: PropTypes.func,
   primaryColor: PropTypes.string,
   videoId: PropTypes.any,
};
MediaImageCard.propTypes = {
   lockedForSFW: PropTypes.bool,
   poster: PropTypes.string,
   setImgLoad: PropTypes.func,
};

MediaAgeVerificationFrame.propTypes = {
   onClickVerifyAgeButton: PropTypes.func,
   src: PropTypes.string,
};

MediaTitile.propTypes = {
   total: PropTypes.number,
   isMobile: PropTypes.bool,
   type: PropTypes.string,
   title: PropTypes.string,
   description: PropTypes.string,
   alignment: PropTypes.string,
   showContentCount: PropTypes.bool,
};
MediaTopLables.propTypes = {
   media: PropTypes.object,
   contentCardSettings: PropTypes.object,
   type: PropTypes.string,
   isMediaContent: PropTypes.bool,
   isProduct: PropTypes.bool,
   toggleWatchStatus: PropTypes.func,
};
MediaCardTitle.propTypes = {
   media: PropTypes.object,
   contentCardSettings: PropTypes.object,
   isAgeVerificationRequired: PropTypes.bool,
   isLoading: PropTypes.bool,
   type: PropTypes.string,
};

MediaContentButtonOptions.propTypes = {
   data: PropTypes.object,
   onClickLike: PropTypes.func,
   goToMediaDetails: PropTypes.func,
   isAuthUser: PropTypes.bool,
   showShare: PropTypes.bool,
   onClickTip: PropTypes.func,
   onShare: PropTypes.func,
   onClickLock: PropTypes.func,
   contentCardSettings: PropTypes.object,
   stream_state: PropTypes.string,
   onChangeFavoriteItem: PropTypes.func,
   likeFetching: PropTypes.bool,
   favoritFetching: PropTypes.bool,
   collectionType: PropTypes.string,
   type: PropTypes.string,
};

MediaMembershipsForContentModal.propTypes = {
   onSelectMembership: PropTypes.func,
   isAgeVerificationRequired: PropTypes.bool,
   type: PropTypes.string,
   onCloseModal: PropTypes.func,
   isLoading: PropTypes.bool,
   pricingsData: PropTypes.object,
   contentName: PropTypes.string,
}
MediaListForPricing.propTypes = {
   pricing: PropTypes.string,
   data: PropTypes.array,
   onSelectMembership: PropTypes.func,
   isAgeVerificationRequired: PropTypes.bool,
}

MediaCardWrapper.propTypes = {
   media: PropTypes.object,
   contentCardSettings: PropTypes.object,
   children: PropTypes.any,
   isLoading: PropTypes.bool,
   toggleWatchStatus: PropTypes.func,
   type: PropTypes.string,
};

MeidaLableWrapper.propTypes = {
   position: PropTypes.string,
   className: PropTypes.string,
   children: PropTypes.any,
};

export {
   MediaCardTitle,
   MediaContentButtonOptions,
   MediaTopLables,
   MediaTitile,
   MediaAgeVerificationFrame,
   MediaListForPricing,
   MediaMembershipsForContentModal,
   MediaPreviewVideo,
   MediaImageCard,
   MediaLockedCard,
   MediaCardWrapper,
   MediaPhotoCard,
};


